// type TagEnum = 'success' | 'info' | 'warning' | 'danger' | 'cyan' | 'blue' | 'red' | 'orange' | 'green' | 'gray'

export var statusOptions = [{
  value: 1,
  label: '启用',
  tag: 'green'
}, {
  value: 0,
  label: '禁用',
  tag: 'red'
}];
export var appCategoryOptions = [{
  value: 1,
  label: '抽奖助手',
  tag: 'default'
}, {
  value: 2,
  label: 'AI算命',
  tag: 'warning'
}, {
  value: 3,
  label: '阅读赚钱',
  tag: 'cyan'
}];
export var appTypeOptions = [{
  value: 1,
  label: '小程序',
  tag: 'green'
}, {
  value: 2,
  label: '公众号',
  tag: 'blue'
}];
export var defaultFormData = {
  appName: '',
  // 应用名称
  appCategory: '',
  // 应用分类
  appType: '',
  // 应用类型
  appId: '',
  // 小程序appid
  appSecret: '',
  // 小程序密钥
  consumerH5Url: '',
  // 企微客服链接
  corpId: '',
  // 企微corpId
  popupId: '',
  // 客服id
  domain: '',
  // 域名
  publicWechatAppid: '',
  // 微信公众号appid
  publicWechatSecret: '',
  // 微信公众号密钥
  verifyToken: '',
  // 微信验证Token
  encodingAesKey: '',
  // EncodingAESKey
  encryptionMethod: 0,
  // 微信消息加密方式
  bindMiniProgramSwitch: 0,
  // H5跳转小程序支付开关
  bindMiniProgramId: '',
  // H5跳转小程序支付小程序id
  readChannelId: '',
  // 阅读渠道id
  wechatPayMerchantConfigIds: [],
  // 微信支付配置id列表
  status: 1 // 状态
};
export var formRules = {
  appName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入应用名称'
  }],
  // appCategory: [{ required: true, trigger: ['blur', 'change'], message: '请选择应用分类' }],
  appType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择应用环境'
  }],
  appId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入小程序appid'
  }],
  appSecret: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入小程序密钥'
  }],
  // popupId: [{ required: true, trigger: ['blur', 'change'], message: '请选择客服' }],
  domain: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入域名'
  }],
  publicWechatAppid: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信公众号appid'
  }],
  publicWechatSecret: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信公众号密钥'
  }],
  verifyToken: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信验证Token'
  }],
  encodingAesKey: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入EncodingAESKey'
  }],
  encryptionMethod: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择微信消息加密方式'
  }]
  // readChannelId: [{ required: true, trigger: ['blur', 'change'], message: '请输入阅读渠道id' }],
};